/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CorporateGroupWithAdministrativeModel } from '../../models/corporate-group-with-administrative-model';

export interface GetApiCorporategroupV1$Json$Params {
  nobreak?: boolean;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiCorporategroupV1$Json(http: HttpClient, rootUrl: string, params?: GetApiCorporategroupV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>> {
  const rb = new RequestBuilder(rootUrl, getApiCorporategroupV1$Json.PATH, 'get');
  if (params) {
    rb.query('nobreak', params.nobreak, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>;
    })
  );
}

getApiCorporategroupV1$Json.PATH = '/private/v1/corporate-groups';
